/**
 * Gate for clinical demo / assistive placeholders.
 *
 * Vite sets import.meta.env.DEV only for local `vite` / development mode.
 * Staging, prep, and production builds (mode staging|prep|production) have
 * DEV=false and PROD=true, so placeholder constants and invented coords must
 * not activate.
 */

export function allowClinicalPlaceholders(): boolean {
  if (typeof import.meta === "undefined") {
    return false;
  }
  const env = (import.meta as ImportMeta & {
    env?: { DEV?: boolean; PROD?: boolean; MODE?: string };
  }).env;
  if (!env) {
    return false;
  }
  const mode = String(env.MODE || "").toLowerCase();
  if (mode === "staging" || mode === "prep" || mode === "production") {
    return false;
  }
  if (env.PROD) {
    return false;
  }
  return Boolean(env.DEV);
}
